import React from 'react';
import Guide from '@src/views/Guide/index';

export const NonVerifiedGuide: React.FC = () => (
  <Guide src="https://guide.a.team/" />
);
